export default __webpack_public_path__ + "static/media/inlock.2f1876b4.svg";